import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { Modal } from 'react-responsive-modal';
import '../../styles/CustomModal.css';
import 'react-responsive-modal/styles.css';

type Props = {
  children: React.ReactNode;
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
};

const CustomModal = ({ children, isVisible, setVisible }: Props) => {
  const [bShowModal, set_bShowModal] = useState(false);

  const onCloseModal = () => {
    set_bShowModal(false);
    setVisible(false);
  };

  useEffect(() => {}, []);

  useEffect(() => {
    set_bShowModal(isVisible);
  }, [isVisible]);

  return (
    <>
      <Style>
        <Modal
          open={bShowModal}
          onClose={onCloseModal}
          center
          classNames={{
            overlay: 'detailModalOverlay',
            modal: 'detailModal',
          }}
          showCloseIcon={false}
          animationDuration={150}>
          <div className="modalContainer">{children}</div>
        </Modal>
      </Style>
    </>
  );
};

export default CustomModal;

const Style = styled.div``;
